/** Тег кешу каталогу одного простору: зміна налаштувань типу запису оновлює лише каталог свого простору (назви типів, типові подання). */
export const catalogTag = (workspaceId: string | undefined) => ({ type: 'Catalog' as const, id: `cat:${workspaceId ?? ''}` });
